import React from "react";
import { connect } from "react-redux";
import PrestacionesEmpresaGrid from "./prestaciones";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
// import SelectTipo from "../../../../Shared/SelectTipo";
import { setTipoPrestacion } from "./actions";
import FormDocumentcion from "./EnvioDocumentos/view";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../../helpers/rolAccess";
import { paths } from "../../../../../config/routes";

class PrestacionesEconomicas extends React.Component {
  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  shouldComponentUpdate = (nextProps) => {
    if (nextProps.isLoading !== this.props.isLoading) {
      return true;
    }

    return false;
  }

  handleSelectTipo = (tipo) => {
    this.props.dispatch(setTipoPrestacion(tipo));
  }

  render() {
    return (
      <div>
        {this.props.isLoading && <LoadingOverlay />}
        <PrestacionesEmpresaGrid />
        <FormDocumentcion />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.prestacionesEmpresa.isLoading || state.documentos.isLoading,
  selectedTipoPrestacion: state.prestacionesEmpresa.selectedTipoPrestacion,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(PrestacionesEconomicas);

